import { dataBarChart } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBarChart = /*#__PURE__*/createIcon(dataBarChart)
export default IconBarChart
